import { React, useState } from "react";
import { Modal } from "@mui/material";
import Swal from "sweetalert2";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { LoaderScreen } from "../../components/LoaderScreen";
import request from "../../../Helpers/API";
import { SearchSelect } from "./SearchSelect";
import { SimpleSelect } from "./SimpleSelect";
import { capitalizePalabras } from "../../../Helpers/CapitalizePalabras";

const camposIniciales = {
    idusuario: "",
    idsucursal: "",
    area: "",
    tipo_usuario: "VA",
};

const TIPO_USUARIO_OPCIONES = [
    { value: "VA", label: "Normal" },
    { value: "SI", label: "Notifica siempre" },
];

const AgregarLeadModal = ({ open, onClose, empleados = [], sucursales = [], areas = [] }) => {
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    const [form, setForm] = useState(camposIniciales);

    const validar = () => {
        if (!form.idusuario) {
            Swal.fire({
                title: "LEADS",
                text: "El usuario responsable es requerido",
                icon: "warning",
                customClass: { container: "mi-superpoop" },
            });
            return false;
        }
        if (!form.idsucursal) {
            Swal.fire({
                title: "LEADS",
                text: "La sucursal es requerida",
                icon: "warning",
                customClass: { container: "mi-superpoop" },
            });
            return false;
        }
        if (!form.area.trim()) {
            Swal.fire({
                title: "LEADS",
                text: "El área es requerida",
                icon: "warning",
                customClass: { container: "mi-superpoop" },
            });
            return false;
        }
        return true;
    };

    const handleGuardar = () => {
        if (!validar()) return;
        setLoader({ ...loader, mostrar: true });

        const post = {
            id_usuario: Number(form.idusuario),
            sucursal: Number(form.idsucursal),
            area: form.area.trim(),
            tipo_usuario: form.tipo_usuario,
            usuario: 0,
        };

        request
            .post("LeadsAgente/AgregarLead", post)
            .then(async () => {
                setLoader({ ...loader, mostrar: false });
                await Swal.fire({
                    title: "LEADS",
                    text: "Responsable agregado con éxito",
                    icon: "success",
                    customClass: { container: "mi-superpoop" },
                });
                handleCancelar();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("LEADS", JSON.stringify(error), "error");
            });
    };

    const handleCancelar = () => {
        setForm(camposIniciales);
        onClose();
    };

    return (
        <Modal open={open} onClose={handleCancelar}>
            <div className="agregar-lead-modal-formulario">
                <div className="agregar-lead-modal-plantilla">
                    <div className="plantilla-screen-filtro-container" id="agregar-lead-modal">
                        <PlantillaScreen
                            titulo="NUEVO RESPONSABLE"
                            className_main={1}
                            className="plantilla-screen-filtro-container-modal"
                        >
                            <div className="cerrar-modal-button" onClick={handleCancelar}>X</div>
                            <LoaderScreen loader={loader} />
                            <div className="agregar-lead-modal-content">
                                <div className="agregar-lead-modal-content-container scroll-4">
                                    <div className="lead-form-group">
                                        <label>Usuario responsable</label>
                                        <SearchSelect
                                            options={empleados.map((emp) => ({ value: emp.idusuario, label: emp.usuario }))}
                                            value={form.idusuario}
                                            onChange={(val) => setForm((prev) => ({ ...prev, idusuario: val }))}
                                            placeholder="Seleccione un usuario"
                                        />
                                    </div>
                                    <div className="lead-form-group">
                                        <label>Sucursal</label>
                                        <SearchSelect
                                            options={sucursales.map((suc) => ({ value: suc.idsucursal, label: capitalizePalabras(suc.sucursal) }))}
                                            value={form.idsucursal}
                                            onChange={(val) => setForm((prev) => ({ ...prev, idsucursal: val }))}
                                            placeholder="Seleccione una sucursal"
                                        />
                                    </div>
                                    <div className="lead-form-group">
                                        <label>Área</label>
                                        <SearchSelect
                                            freeSolo
                                            options={areas.map((a) => ({ value: a.area, label: a.area }))}
                                            value={form.area}
                                            onChange={(val) => setForm((prev) => ({ ...prev, area: val }))}
                                            placeholder="Escriba o seleccione un área"
                                        />
                                    </div>
                                    <div className="lead-form-group">
                                        <label>Tipo de usuario</label>
                                        <SimpleSelect
                                            options={TIPO_USUARIO_OPCIONES}
                                            value={form.tipo_usuario}
                                            onChange={(val) => setForm((prev) => ({ ...prev, tipo_usuario: val }))}
                                            placeholder="Seleccione el tipo de usuario"
                                        />
                                    </div>
                                </div>
                                <div className="agregar-lead-modal-buttons">
                                    <button
                                        className="agregar-lead-modal-button-cancelar"
                                        onClick={handleCancelar}
                                    >
                                        Cancelar
                                    </button>
                                    <button
                                        className="agregar-lead-modal-button-guardar"
                                        onClick={handleGuardar}
                                        disabled={loader.mostrar}
                                    >
                                        Guardar
                                    </button>
                                </div>
                            </div>
                        </PlantillaScreen>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default AgregarLeadModal;
